/**
 * Microsoft Dataverse environment configuration.
 * Single source of truth for base URL and CRM entity table names.
 */

/** DEV Dataverse environment URL */
// export const ENVIRONMENT_URL = 'https://org487f0635.api.crm8.dynamics.com'; // DEV org
export const ENVIRONMENT_URL = 'https://orgea61b289.crm8.dynamics.com'; // PROD org


/** @deprecated Use ENVIRONMENT_URL — kept for existing imports */
export const DATAVERSE_BASE_URL = ENVIRONMENT_URL;

export const DATAVERSE_API_VERSION = '9.2';

/** Dataverse entity logical names (DEV tables) */
// export const DATAVERSE_TABLES = {
//   ALC: 'cr3ea_alcs',
//   PROOFING: 'cr3ea_proofings',
//   PROCESS_FORMAT: 'cr3ea_processformats',
//   BACKING_MIXING: 'cr3e_mixings',
//   BACKING_CODING: 'cr3ea_codings',
//   SIEVES_AND_MAGNETS: 'cr3ea_sievesandmagnets',
//   SIEVES_AND_MAGNETS_NEW_PLANT: 'cr3ea_sievesandmagnetsnewplants',
//   SIEVES_AND_MAGNETS_OLD_PLANT: 'cr3ea_sievesandmagnetsoldplants',
//   CODE_VERIFICATION: 'cr3ea_codeverifications',
//   NET_WEIGHT: 'cr3ea_netweights',
//   MIXING_PARAMETERS: 'cr3ea_mixingparameters',
//   OPRP_AND_CCP: 'cr3ea_oprpandcpps',
//   BAKING: 'cr3ea_bakings',
//   BAKING_AND_COOLING: 'cr3ea_bakingandcoolings',
//   QUALITY_WALL: 'cr3ea_qualitywalls',
//   CREAM_PERCENTAGE: 'cr3ea_creams',
//   DEPARTMENT_TOUR: 'cr3ea_departmenttours',
//   QUALITY_TOUR: 'cr3ea_qualitytours',
//   OBSERVATIONS: 'cr3ea_observationses',
//   PQI_BAKERIES: 'cr3ea_pqi_bakeries',
//   PQI_FRONTS: 'cr3ea_pqi_fronts',
//   PRODUCT_MONITORING: 'cr3ea_productmonitorings',
//   SEAL_INTEGRITY: 'cr3ea_vlts',
// } as const;

/** Dataverse entity logical names (production tables) */
export const DATAVERSE_TABLES = {
  ALC: 'cr3ea_prod_alcs',
  PROOFING: 'cr3ea_prod_proofings',
  PROCESS_FORMAT: 'cr3ea_prod_processformats',
  BACKING_MIXING: 'cr3ea_prod_mixings',
  BACKING_CODING: 'cr3ea_prod_codings',
  SIEVES_AND_MAGNETS: 'cr3ea_prod_sievesandmagnets',
  SIEVES_AND_MAGNETS_NEW_PLANT: 'cr3ea_prod_sievesandmagnetsnewplants',
  SIEVES_AND_MAGNETS_OLD_PLANT: 'cr3ea_prod_sievesandmagnetsoldplants',
  CODE_VERIFICATION: 'cr3ea_prod_codeverifications',
  NET_WEIGHT: 'cr3ea_prod_netweights',
  MIXING_PARAMETERS: 'cr3ea_prod_mixingparameters',
  OPRP_AND_CCP: 'cr3ea_prod_oprpandcpps',
  BAKING: 'cr3ea_prod_bakings',
  BAKING_AND_COOLING: 'cr3ea_prod_bakingandcoolings',
  QUALITY_WALL: 'cr3ea_prod_qualitywalls',
  CREAM_PERCENTAGE: 'cr3ea_prod_creams',
  DEPARTMENT_TOUR: 'cr3ea_prod_departmenttours',
  QUALITY_TOUR: 'cr3ea_prod_qualitytours',
  OBSERVATIONS: 'cr3ea_prod_observationses',
  PQI_BAKERIES: 'cr3ea_prod_pqi_bakeries',
  PQI_FRONTS: 'cr3ea_prod_pqi_fronts',
  PRODUCT_MONITORING: 'cr3ea_prod_productmonitorings',
  SEAL_INTEGRITY: 'cr3ea_prod_vlts',
} as const;

/** Dataverse entity logical names (standard CRM tables) */
// export const DATAVERSE_TABLES = {
//   ALC: 'cr3ea_prod_alcs',
//   PROOFING: 'cr3ea_prod_proofings',
//   PROCESS_FORMAT: 'cr3ea_prod_processformats',
//   BACKING_MIXING: 'cr3ea_prod_mixings',
//   BACKING_CODING: 'cr3ea_prod_codings',
//   SIEVES_AND_MAGNETS: 'cr3ea_prod_sievesandmagnets',
//   SIEVES_AND_MAGNETS_NEW_PLANT: 'cr3ea_prod_sievesandmagnetsnewplants',
//   SIEVES_AND_MAGNETS_OLD_PLANT: 'cr3ea_prod_sievesandmagnetsoldplants',
//   CODE_VERIFICATION: 'cr3ea_prod_codeverifications',
//   NET_WEIGHT: 'cr3ea_prod_netweights',
//   MIXING_PARAMETERS: 'cr3ea_prod_mixingparameters',
//   OPRP_AND_CCP: 'cr3ea_prod_oprpandcpps',
//   BAKING: 'cr3ea_prod_bakings',
//   BAKING_AND_COOLING: 'cr3ea_prod_bakingandcoolings',
//   QUALITY_WALL: 'cr3ea_prod_qualitywalls',
//   CREAM_PERCENTAGE: 'cr3ea_prod_creams',
//   DEPARTMENT_TOUR: 'cr3ea_prod_departmenttours',
//   QUALITY_TOUR: 'cr3ea_prod_qualitytours',
//   OBSERVATIONS: 'cr3ea_prod_observationses',
//   PQI_BAKERIES: 'cr3ea_prod_pqi_bakeries',
//   PQI_FRONTS: 'cr3ea_prod_pqi_fronts',
//   PRODUCT_MONITORING: 'cr3ea_prod_productmonitorings',
//   SEAL_INTEGRITY: 'cr3ea_prod_vlts',
// } as const;


export type DataverseTableName =
  (typeof DATAVERSE_TABLES)[keyof typeof DATAVERSE_TABLES];

/** Dynamic active environment resolver matching source code utils.js */
export type DataverseEnv = 'DEV' | 'UAT' | 'PROD';

// ─── DEV Tables (cr3ea_rajpura_... prefix — no prod_) ───────────────────────
// Active for DEV environment.
// export const RAJPURA_DEV_TABLES = {
//   PARENT_TOUR: "cr3ea_rajpura_quality_tours",
//   ALC: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD: "cr3ea_rajpura_alcses"
//   },
//   FOOD_SAFETY: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD: "cr3ea_foodsafetychecklistforrajpuras"
//   },
//   MIXING_BAKING: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD: "cr3ea_rajpura_mixingandbakings"
//   },
//   PACKAGING_OPERATIONS: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD_TEMP_HUMIDITY: "cr3ea_rajpura_pkgops_temphumidities",
//     CHILD_CODE_VERIFICATION: "cr3ea_rajpura_pkgops_codeverifications",
//     CHILD_PAPA: "cr3ea_rajpura_pkgops_papas",
//     CHILD_PQI_NET_WEIGHT: "cr3ea_rajpura_pkgops_pqi_netweights",
//     CHILD_PQI_EVALUATION: "cr3ea_rajpura_pkgops_pqi_evaluations",
//     CHILD_SEAL_INTEGRITY: "cr3ea_rajpura_pkgops_sealintegrities",
//     CHILD_QUALITY_WALL: "cr3ea_rajpura_pkgops_qualitywalls"
//   },
//   CCP_OPRP_SIEVES_MAGNETS: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD_CCP: "cr3ea_rajpura_ccpoprps",
//     CHILD_SIEVES: "cr3ea_rajpura_sievesmagnetses"
//   }
// };

// ─── PROD Tables (cr3ea_prod_rajpura_... prefix) ─────────────────────────────
// Uncomment when targeting PROD environment.
export const RAJPURA_DEV_TABLES = {
  PARENT_TOUR: "cr3ea_prod_rajpura_quality_tours",
  ALC: {
    PARENT: "cr3ea_prod_rajpura_quality_tours",
    CHILD: "cr3ea_prod_rajpura_alcses"
  },
  FOOD_SAFETY: {
    PARENT: "cr3ea_prod_rajpura_quality_tours",
    CHILD: "cr3ea_prod_foodsafetychecklistforrajpuras"
  },
  MIXING_BAKING: {
    PARENT: "cr3ea_prod_rajpura_quality_tours",
    CHILD: "cr3ea_prod_rajpura_mixingandbakings"
  },
  PACKAGING_OPERATIONS: {
    PARENT: "cr3ea_prod_rajpura_quality_tours",
    CHILD_TEMP_HUMIDITY: "cr3ea_prod_rajpura_pkgops_temphumidities",
    CHILD_CODE_VERIFICATION: "cr3ea_prod_rajpura_pkgops_codeverifications",
    CHILD_PAPA: "cr3ea_prod_rajpura_pkgops_papas",
    CHILD_PQI_NET_WEIGHT: "cr3ea_prod_rajpura_pkgops_pqi_netweights",
    CHILD_PQI_EVALUATION: "cr3ea_prod_rajpura_pkgops_pqi_evaluations",
    CHILD_SEAL_INTEGRITY: "cr3ea_prod_rajpura_pkgops_sealintegrities",
    CHILD_QUALITY_WALL: "cr3ea_prod_rajpura_pkgops_qualitywalls"
  },
  CCP_OPRP_SIEVES_MAGNETS: {
    PARENT: "cr3ea_prod_rajpura_quality_tours",
    CHILD_CCP: "cr3ea_prod_rajpura_ccpoprps",
    CHILD_SIEVES: "cr3ea_prod_rajpura_sievesmagnetses"
  }
};

// ─── UAT Tables (cr3ea_rajpura_... prefix — same as DEV currently) ────────────
// export const RAJPURA_UAT_TABLES = {
//   PARENT_TOUR: "cr3ea_rajpura_quality_tours",
//   ALC: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD: "cr3ea_rajpura_alcses"
//   },
//   FOOD_SAFETY: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD: "cr3ea_foodsafetychecklistforrajpuras"
//   },
//   MIXING_BAKING: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD: "cr3ea_rajpura_mixingandbakings"
//   },
//   PACKAGING_OPERATIONS: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD_TEMP_HUMIDITY: "cr3ea_rajpura_pkgops_temphumidities",
//     CHILD_CODE_VERIFICATION: "cr3ea_rajpura_pkgops_codeverifications",
//     CHILD_PAPA: "cr3ea_rajpura_pkgops_papas",
//     CHILD_PQI_NET_WEIGHT: "cr3ea_rajpura_pkgops_pqi_netweights",
//     CHILD_PQI_EVALUATION: "cr3ea_rajpura_pkgops_pqi_evaluations",
//     CHILD_SEAL_INTEGRITY: "cr3ea_rajpura_pkgops_sealintegrities",
//     CHILD_QUALITY_WALL: "cr3ea_rajpura_pkgops_qualitywalls"
//   },
//   CCP_OPRP_SIEVES_MAGNETS: {
//     PARENT: "cr3ea_rajpura_quality_tours",
//     CHILD_CCP: "cr3ea_rajpura_ccpoprps",
//     CHILD_SIEVES: "cr3ea_rajpura_sievesmagnetses"
//   }
// };

// ─── PROD Table definitions (kept as reference / for easy switch-back) ────────
// These are now mirrored in the active RAJPURA_DEV_TABLES block above.
// export const RAJPURA_PROD_TABLES = {
//   PARENT_TOUR: "cr3ea_prod_rajpura_quality_tours",
//   ALC: {
//     PARENT: "cr3ea_prod_rajpura_quality_tours",
//     CHILD: "cr3ea_prod_rajpura_alcses"
//   },
//   FOOD_SAFETY: {
//     PARENT: "cr3ea_prod_rajpura_quality_tours",
//     CHILD: "cr3ea_prod_foodsafetychecklistforrajpuras"
//   },
//   MIXING_BAKING: {
//     PARENT: "cr3ea_prod_rajpura_quality_tours",
//     CHILD: "cr3ea_prod_rajpura_mixingandbakings"
//   },
//   PACKAGING_OPERATIONS: {
//     PARENT: "cr3ea_prod_rajpura_quality_tours",
//     CHILD_TEMP_HUMIDITY: "cr3ea_prod_rajpura_pkgops_temphumidities",
//     CHILD_CODE_VERIFICATION: "cr3ea_prod_rajpura_pkgops_codeverifications",
//     CHILD_PAPA: "cr3ea_prod_rajpura_pkgops_papas",
//     CHILD_PQI_NET_WEIGHT: "cr3ea_prod_rajpura_pkgops_pqi_netweights",
//     CHILD_PQI_EVALUATION: "cr3ea_prod_rajpura_pkgops_pqi_evaluations",
//     CHILD_SEAL_INTEGRITY: "cr3ea_prod_rajpura_pkgops_sealintegrities",
//     CHILD_QUALITY_WALL: "cr3ea_prod_rajpura_pkgops_qualitywalls"
//   },
//   CCP_OPRP_SIEVES_MAGNETS: {
//     PARENT: "cr3ea_prod_rajpura_quality_tours",
//     CHILD_CCP: "cr3ea_prod_rajpura_ccpoprps",
//     CHILD_SIEVES: "cr3ea_prod_rajpura_sievesmagnetses"
//   }
// };

export const RAJPURA_ENVIRONMENTS = {
  // ─── DEV Environment (ACTIVE) ───────────────────────────────────────────────
  // DEV: {
  //   TENANT_URL: "https://aufaitcloud.sharepoint.com/sites/Mrs_Bectors_PTMS",
  //   DATAVERSE_URL: "https://org487f0635.crm8.dynamics.com",
  //   PLANT_ID: "14",
  //   PLANT_NAME: "Rajpura",
  //   QUALITY_DEPT_IDS: ["80", "81", "135"],
  //   DATAVERSE_TABLES: RAJPURA_DEV_TABLES
  // },

  // ─── UAT Environment ───────────────────────────────────────────────────────
  // Uncomment to switch to UAT.
  // UAT: {
  //   TENANT_URL: "https://bectors.sharepoint.com/sites/PTMS_UAT",
  //   DATAVERSE_URL: "https://orgea61b289.crm8.dynamics.com",
  //   PLANT_ID: "2",
  //   PLANT_NAME: "Rajpura",
  //   QUALITY_DEPT_IDS: ["18", "81", "135"],
  //   DATAVERSE_TABLES: 
  // },

  // ─── PROD Environment ──────────────────────────────────────────────────────
  PROD: {
    TENANT_URL: "https://bectors.sharepoint.com/sites/PTMS_PRD",
    DATAVERSE_URL: "https://orgea61b289.crm8.dynamics.com",
    PLANT_ID: "2",
    PLANT_NAME: "Rajpura",
    QUALITY_DEPT_IDS: ["39", "81", "135"],
    DATAVERSE_TABLES: RAJPURA_DEV_TABLES
  }
};

/** Resolves current environment. Change return value to switch environments: "DEV" | "UAT" | "PROD" */
export function getRajpuraEnvironment(): DataverseEnv {
  return "DEV";  // ← ACTIVE: DEV
  // return "UAT";  // ← uncomment for UAT
  // return "PROD";    // ← uncomment for PROD
}

// export function getRajpuraConfig() {
//   return RAJPURA_ENVIRONMENTS.DEV;
// }

/** Dataverse entity logical names for Rajpura specific tables (DEV active) */
export const RAJPURA_TABLES = {
  DEV: RAJPURA_DEV_TABLES,

  // Direct aliases for DEV environment tables
  QUALITY_TOUR: RAJPURA_DEV_TABLES.PARENT_TOUR,
  ALCS: RAJPURA_DEV_TABLES.ALC.CHILD,
  FOOD_SAFETY: RAJPURA_DEV_TABLES.FOOD_SAFETY.CHILD,
  MIXING_AND_BAKING: RAJPURA_DEV_TABLES.MIXING_BAKING.CHILD,
  CCP_OPRP: RAJPURA_DEV_TABLES.CCP_OPRP_SIEVES_MAGNETS.CHILD_CCP,
  SIEVES_MAGNETS: RAJPURA_DEV_TABLES.CCP_OPRP_SIEVES_MAGNETS.CHILD_SIEVES,
  PACKAGING_OPERATIONS: {
    TEMP_HUMIDITY: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_TEMP_HUMIDITY,
    CODE_VERIFICATION: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_CODE_VERIFICATION,
    PAPA: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_PAPA,
    PQI_NET_WEIGHT: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_PQI_NET_WEIGHT,
    PQI_EVALUATION: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_PQI_EVALUATION,
    SEAL_INTEGRITY: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_SEAL_INTEGRITY,
    QUALITY_WALL: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_QUALITY_WALL,
  },

  // DEV / UAT aliases (cr3ea_ prefix without prod_)
  DEV_UAT: {
    QUALITY_TOUR: RAJPURA_DEV_TABLES.PARENT_TOUR,
    ALCS: RAJPURA_DEV_TABLES.ALC.CHILD,
    FOOD_SAFETY: RAJPURA_DEV_TABLES.FOOD_SAFETY.CHILD,
    MIXING_AND_BAKING: RAJPURA_DEV_TABLES.MIXING_BAKING.CHILD,
    CCP_OPRP: RAJPURA_DEV_TABLES.CCP_OPRP_SIEVES_MAGNETS.CHILD_CCP,
    SIEVES_MAGNETS: RAJPURA_DEV_TABLES.CCP_OPRP_SIEVES_MAGNETS.CHILD_SIEVES,
    PACKAGING_OPERATIONS: {
      TEMP_HUMIDITY: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_TEMP_HUMIDITY,
      CODE_VERIFICATION: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_CODE_VERIFICATION,
      PAPA: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_PAPA,
      PQI_NET_WEIGHT: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_PQI_NET_WEIGHT,
      PQI_EVALUATION: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_PQI_EVALUATION,
      SEAL_INTEGRITY: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_SEAL_INTEGRITY,
      QUALITY_WALL: RAJPURA_DEV_TABLES.PACKAGING_OPERATIONS.CHILD_QUALITY_WALL,
    }
  }
} as const;

export type RajpuraTableName =
  (typeof RAJPURA_TABLES)[keyof typeof RAJPURA_TABLES];

/** Helper to resolve Tour ID across PROD, DEV, UAT and custom schema variants */
export function getRajpuraTourId(t: any): string {
  if (!t) return "";
  return (
    t.cr3ea_prod_rajpura_quality_tourid ||
    t.cr3ea_rajpura_quality_tourid ||
    t.cr3ea_prod_qualitytourid ||
    t.cr3ea_qualitytourid ||
    t.id ||
    t._tourId ||
    ""
  );
}

/** Strict column whitelist for the Parent Tour entity matching legacy utils.js */
export const PARENT_TOUR_COLUMNS = [
  "cr3ea_title",
  "cr3ea_tourstartdate",
  "cr3ea_plantid",
  "cr3ea_shift",
  "cr3ea_lineno",
  "cr3ea_assigned_qa",
  "cr3ea_shiftexecutiveproduction",
  "cr3ea_status",
  "cr3ea_processstatus",
  "cr3ea_observedby",
  "cr3ea_tourby",
  "cr3ea_previousrunningvariety",
  "cr3ea_runningvariety",
  "cr3ea_executivename",
  "cr3ea_overall_score",
  "cr3ea_total_checkpoints",
  "cr3ea_compliant_count",
  "cr3ea_non_compliant_count",
  "cr3ea_escalation_contacts",
  "cr3ea_islineclear",
  "cr3ea_pkgops_type",
  "cr3ea_ccp_oprp_sieves_parametertype",
  "cr3ea_ccp_oprp_sieves_frequency",
  "cr3ea_food_safety_checklisttype",
  "cr3ea_batchno",
  "cr3ea_cycle"
] as const;

/** Sanitizes parent tour payload by removing invalid non-schema fields before sending to Dataverse */
export function sanitizeParentTourPayload(payload: any): any {
  if (!payload || typeof payload !== "object") return payload;
  const clean: any = {};
  const validSet = new Set<string>(PARENT_TOUR_COLUMNS);

  // Map common aliases to proper schema column names
  if (payload.cr3ea_lineid && !payload.cr3ea_lineno) payload.cr3ea_lineno = payload.cr3ea_lineid;
  if (payload.cr3ea_food_safety_cycle && !payload.cr3ea_cycle) payload.cr3ea_cycle = payload.cr3ea_food_safety_cycle;
  if (payload.cr3ea_ccp_oprp_sieves_productvariety && !payload.cr3ea_runningvariety) payload.cr3ea_runningvariety = payload.cr3ea_ccp_oprp_sieves_productvariety;
  if (payload.cr3ea_shiftexecutivequality && !payload.cr3ea_executivename) payload.cr3ea_executivename = payload.cr3ea_shiftexecutivequality;
  if (payload.cr3ea_production_incharge && !payload.cr3ea_shiftexecutiveproduction) payload.cr3ea_shiftexecutiveproduction = payload.cr3ea_production_incharge;
  if (payload.cr3ea_qaexecutive && !payload.cr3ea_assigned_qa) payload.cr3ea_assigned_qa = payload.cr3ea_qaexecutive;
  if (payload.cr3ea_shiftexecutive && !payload.cr3ea_observedby) payload.cr3ea_observedby = payload.cr3ea_shiftexecutive;

  for (const key of Object.keys(payload)) {
    if (validSet.has(key)) {
      clean[key] = payload[key];
    }
  }
  return clean;
}

/** Build a Dataverse OData entity URL for POST/PATCH */
export function buildDataverseEntityUrl(
  tableName: string,
  apiVersion: string = DATAVERSE_API_VERSION
): string {
  return `${ENVIRONMENT_URL}/api/data/v${apiVersion}/${tableName}`;
}

/** Build a Dataverse OData query URL with filter and select */
export function buildDataverseQueryUrl(
  tableName: string,
  query: string,
  apiVersion: string = DATAVERSE_API_VERSION
): string {
  return `${ENVIRONMENT_URL}/api/data/v${apiVersion}/${tableName}?${query}`;
}
